import {
  WhatsAppLogCallsResponseSchema,
  WhatsAppLogMessagesResponseSchema,
  type WhatsAppLogCallsResponse,
  type WhatsAppLogMessagesResponse,
  type WhatsAppLogQuery,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Admin-only WhatsApp delivery log. Agents never see a failed send in the
 * chat widget; this is where those land, with the lead and its owner.
 */
export const listWhatsAppLogMessages = async (
  query: WhatsAppLogQuery,
): Promise<WhatsAppLogMessagesResponse> => {
  const { data } = await apiClient.get<unknown>('/whatsapp/log/messages', { params: query });
  return WhatsAppLogMessagesResponseSchema.parse(data);
};

export const listWhatsAppLogCalls = async (
  query: WhatsAppLogQuery,
): Promise<WhatsAppLogCallsResponse> => {
  const { data } = await apiClient.get<unknown>('/whatsapp/log/calls', { params: query });
  return WhatsAppLogCallsResponseSchema.parse(data);
};
